module.exports = __webpack_public_path__ + "media/images/top/ranking_t-0976f3451090d89f90ebc38de39f87a4.gif";